import BaseController from "confinus_ui/base_controller";

// Active/inactive classes for the segmented-control buttons.
const ACTIVE_CLASSES = [
  "bg-white",
  "dark:bg-slate-800",
  "text-primary-700",
  "dark:text-primary-300",
  "shadow-sm",
];
const INACTIVE_CLASSES = [
  "text-slate-600",
  "dark:text-slate-300",
  "hover:text-slate-900",
];

// Toggles which recipient picker is active, writes the chosen scope into a
// hidden input, reflects the selected segment, and reveals the group-name
// field when 2+ admins are selected.
export default class extends BaseController {
  static targets = ["scopeInput", "panel", "groupName", "scopeButton"];

  declare readonly scopeInputTarget: HTMLInputElement;
  declare readonly panelTargets: HTMLElement[];
  declare readonly hasGroupNameTarget: boolean;
  declare readonly groupNameTarget: HTMLElement;
  declare readonly scopeButtonTargets: HTMLElement[];

  connect() {
    super.connect();
    this.reflectActiveScope(this.scopeInputTarget.value);
    this.updateGroupName();
  }

  selectScope(event: Event) {
    const scope = (event.currentTarget as HTMLElement).dataset.scope || "";
    this.scopeInputTarget.value = scope;
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.scope !== scope;
    });
    this.reflectActiveScope(scope);
    this.updateGroupName();
  }

  private reflectActiveScope(scope: string) {
    this.scopeButtonTargets.forEach((btn) => {
      const active = btn.dataset.scope === scope;
      ACTIVE_CLASSES.forEach((c) => btn.classList.toggle(c, active));
      INACTIVE_CLASSES.forEach((c) => btn.classList.toggle(c, !active));
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  // Bound to the multi-select's scoped selected/removed events.
  recipientsChanged(_event: Event) {
    this.updateGroupName();
  }

  private updateGroupName() {
    if (!this.hasGroupNameTarget) return;
    const active = this.panelTargets.find((p) => !p.hidden);
    const count = active
      ? active.querySelectorAll(
          'input[type="hidden"][name="messages_forms_thread[recipient_encoded_ids][]"]',
        ).length
      : 0;
    this.groupNameTarget.hidden = !(
      this.scopeInputTarget.value === "admins" && count >= 2
    );
  }
}
